import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const HOME_TITLE = 'home title'
export const SCHEME_SUGGESTER = 'Schema Suggester'
export const SUB_TITLE = 'sub title'
export const ALL_SURVEYS = 'all surveys'
export const BACK = 'back'
export const SAVE = 'save'
export const TEST = 'test'
export const NEW_GROUP = 'new group'
export const ADD_TEMPLATE = 'Add template'
export const SURVEY_SETTINGS = 'Survey Settings'
export const SURVEY_SAVED_SUCCESS = 'survey saved success'
export const GROUP_ADDED = 'group added'
export const UPLOAD = 'upload'
export const QUESTION_CODE_ERROR = 'question code error'
export const EMPTY_QUESTION_GROUP = 'empty question group'
export const CUSTOMIZE = 'customize'

export default {
  [PORTUGUESE]: {
    [HOME_TITLE]: 'Pagina Inicial',
    [SCHEME_SUGGESTER]: 'Sugestão de Estrutura',
    [SUB_TITLE]: 'Estas são sugestões, você pode personalizar cada uma.',
    [ALL_SURVEYS]: 'Todas as Pesquisas',
    [BACK]: 'Voltar',
    [SAVE]: 'Salvar',
    [TEST]: 'Teste',
    [NEW_GROUP]: 'Adicionar novo grupo',
    [ADD_TEMPLATE]: 'Adicionar modelo',
    [SURVEY_SETTINGS]: 'Configurações de pesquisa',
    [SURVEY_SAVED_SUCCESS]: 'Pesquisa salva com sucesso',
    [GROUP_ADDED]: 'Grupo adicionado com sucesso',
    [UPLOAD]: 'Upload',
    [QUESTION_CODE_ERROR]:
      'O código da questão não pode começar com número e não pode ser somente números.',
    [EMPTY_QUESTION_GROUP]: 'O grupo de questão não pode estar vazio.',
    [CUSTOMIZE]: 'Customizar',
  },

  [ENGLISH]: {
    [HOME_TITLE]: 'Home',
    [SCHEME_SUGGESTER]: 'Schema Suggester',
    [SUB_TITLE]: 'These are suggestions, you can customize each one.',
    [ALL_SURVEYS]: 'All Surveys',
    [BACK]: 'Back',
    [SAVE]: 'Save',
    [TEST]: 'Test',
    [NEW_GROUP]: 'Add new group',
    [ADD_TEMPLATE]: 'Add template',
    [SURVEY_SETTINGS]: 'Survey Settings',
    [SURVEY_SAVED_SUCCESS]: 'Survey saved with success',
    [GROUP_ADDED]: 'Group added successfully',
    [UPLOAD]: 'Upload',
    [QUESTION_CODE_ERROR]:
      'The question code cannot start with a number and cannot be just numbers.',
    [EMPTY_QUESTION_GROUP]: 'The question group cannot be empty.',
    [CUSTOMIZE]: 'Customize',
  },

  [SPANISH]: {
    [HOME_TITLE]: 'Página de Inicio',
    [SCHEME_SUGGESTER]: 'Estructura de la Encuesta',
    [SUB_TITLE]: 'Estas son sugerencias, puedes personalizar cada una.',
    [ALL_SURVEYS]: 'Todas las Encuestas',
    [BACK]: 'Atrás',
    [SAVE]: 'Guardar',
    [TEST]: 'Prueba',
    [NEW_GROUP]: 'Agregar nuevo grupo',
    [ADD_TEMPLATE]: 'Agregar modelo',
    [SURVEY_SETTINGS]: 'Configuración de la encuesta',
    [SURVEY_SAVED_SUCCESS]: 'Encuesta guardada con éxito',
    [GROUP_ADDED]: 'Grupo añadido con éxito',
    [UPLOAD]: 'Upload',
    [QUESTION_CODE_ERROR]:
      'El código de pregunta no puede comenzar con un número y no puede ser solo números.',
    [EMPTY_QUESTION_GROUP]: 'El grupo de preguntas no puede estar vacío.',
    [CUSTOMIZE]: 'Personalizar',
  },
}
